import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useTranslation } from '@/contexts/LanguageContext';

interface YearPickerProps {
  selectedYear: number | null;
  onYearChange: (year: number) => void;
}

export function YearPicker({ selectedYear, onYearChange }: YearPickerProps) {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  return (
    <div className="space-y-2">
      <Label>{t('year')}</Label>
      <Select
        value={selectedYear?.toString() || ''}
        onValueChange={(value) => onYearChange(parseInt(value))}
      >
        <SelectTrigger>
          <SelectValue placeholder={t('selectYear')} />
        </SelectTrigger>
        <SelectContent className="z-[100]">
          {years.map((year) => (
            <SelectItem key={year} value={year.toString()}>
              {year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {selectedYear && (
        <p className="text-sm text-muted-foreground">
          {t('validityPeriod')}: 01/01/{selectedYear} - 31/12/{selectedYear}
        </p>
      )}
    </div>
  );
}
